import { createAction, props } from '@ngrx/store';
import type {
  BiomapHabitatClassification,
  BiomapMsaComponent,
} from '../../../interfaces/biomap/IBiomapLayer';
import type {
  IBiomapProtectedAreaLookupRequest,
  IBiomapProtectedAreaLookupResponse,
  IBiomapProtectedAreaProjectLookupOptions,
  IBiomapProtectedAreaMatch,
} from '../../../interfaces/biomap/IBiomapProtectedArea';
import type {
  IBiomapExplorerKpiRequestContext,
  IBiomapMsaHighValueAreaKpi,
  IBiomapVectorKpiPayload,
} from '../../../interfaces/biomap/IBiomapExplorerKpi';

export const setBiomapHabitatClassification = createAction(
  '[BIOMAP Explorer] Set Habitat Classification',
  props<{ classification: BiomapHabitatClassification }>(),
);

export const setBiomapMsaComponent = createAction(
  '[BIOMAP Explorer] Set MSA Component',
  props<{ component: BiomapMsaComponent }>(),
);

export const hydrateBiomapLayerSelection = createAction(
  '[BIOMAP Explorer] Hydrate Layer Selection',
  props<{
    habitatClassification?: BiomapHabitatClassification;
    msaComponent?: BiomapMsaComponent;
  }>(),
);

export const loadBiomapExplorerKpi = createAction(
  '[BIOMAP] Load Explorer KPI',
  props<{
    projectUuid: string | null;
    rasterLayerUuid: string;
    vectorKpiUuid: string;
    context: IBiomapExplorerKpiRequestContext;
  }>(),
);

export const loadBiomapExplorerKpiSuccess = createAction(
  '[BIOMAP] Load Explorer KPI Success',
  props<{
    rasterLayerUuid: string;
    payload: IBiomapVectorKpiPayload;
    preferredYear?: number;
  }>(),
);

export const loadBiomapExplorerKpiFailure = createAction(
  '[BIOMAP] Load Explorer KPI Failure',
  props<{ rasterLayerUuid: string; error: string }>(),
);

export const clearBiomapExplorerKpi = createAction(
  '[BIOMAP] Clear Explorer KPI',
  props<{ rasterLayerUuid: string }>(),
);

export const setBiomapExplorerKpiYear = createAction(
  '[BIOMAP Explorer] Set KPI Year',
  props<{ rasterLayerUuid: string; year: number }>(),
);

export const focusBiomapProtectedArea = createAction(
  '[BIOMAP Explorer] Focus Protected Area',
  props<{ protectedArea: IBiomapProtectedAreaMatch }>(),
);

export const focusBiomapMsaHighValueArea = createAction(
  '[BIOMAP Explorer] Focus MSA High Value Area',
  props<{ area: IBiomapMsaHighValueAreaKpi }>(),
);

export const clearBiomapExplorerOverlays = createAction(
  '[BIOMAP Explorer] Clear Map Overlays',
);

export const loadBiomapProjectProtectedAreas = createAction(
  '[BIOMAP] Load Project Protected Areas',
  props<{
    projectUuid: string;
    options?: IBiomapProtectedAreaProjectLookupOptions;
  }>(),
);

export const lookupBiomapProtectedAreas = createAction(
  '[BIOMAP] Lookup Protected Areas',
  props<{
    projectUuid: string;
    request: IBiomapProtectedAreaLookupRequest;
  }>(),
);

export const loadBiomapProtectedAreasSuccess = createAction(
  '[BIOMAP] Load Protected Areas Success',
  props<{ response: IBiomapProtectedAreaLookupResponse }>(),
);

export const loadBiomapProtectedAreasFailure = createAction(
  '[BIOMAP] Load Protected Areas Failure',
  props<{ error: string }>(),
);

export const clearBiomapProtectedAreas = createAction(
  '[BIOMAP] Clear Protected Areas',
);

export const resetBiomapState = createAction('[BIOMAP] Reset State');
